import type { IMFile } from '@wui/im'
import type { InjectionKey, Ref } from 'vue'

export type AttachmentViewerMode = 'media' | 'document'

export type AttachmentViewerActions = {
  zoomIn?: () => void
  zoomOut?: () => void
  rotate?: () => void
  toggleFullscreen?: () => void
  isVideo?: Ref<boolean>
  isLoading?: Ref<boolean>
  downloadFiles?: Ref<IMFile[]>
  downloadIndex?: Ref<number>
}

export type AttachmentViewerContext = {
  mode: Ref<AttachmentViewerMode>
  currentFile: Ref<IMFile | undefined>
  isFullscreen: Ref<boolean>
  viewerActions: Ref<AttachmentViewerActions>
  registerActions: (actions: AttachmentViewerActions) => void
  registerContentRef: (element: Ref<HTMLElement | undefined>) => void
}

export const attachmentViewerContextKey: InjectionKey<AttachmentViewerContext> = Symbol('attachmentViewerContext')
